import type {Diagnostic} from "~/types/diagnostic";
import type {Theme} from "~/types/theme";
import type {Rates} from "~/types/Rates";
import type {Stats} from "~/types/Stats";
import type {PerimeterType} from "~/types/PerimeterType";

export function getThemes(diagnostics: Diagnostic[] | undefined) {
    return useUniqBy(diagnostics?.flatMap((diag) => diag.themes), 'id')
}

export function getThemeLabels(diagnostics: Diagnostic[] | undefined) {
    return useUniqBy(useFlatMap(diagnostics, (diagnostic: Diagnostic) => {
        return useMap(diagnostic.themes, (theme) => {
            return {
                title: theme.label,
                id: theme.id,
                icon: theme.iconUrl ?? '',
                subThemes: theme.subThemes
            }
        })
    }), 'id')
}

export function getItemsForThemes(diagnostics: Diagnostic[] | undefined) {
    return diagnostics?.map((diag) => ({
        perimeter: diag.perimeter,
        completion: diag.rates.completion,
        satisfaction: diag.rates.satisfaction,
        notApplicable: diag.rates.notApplicable,
        themes: diag.themes.map((theme) => ({
            id: theme.id,
            rates: theme.rates,
        }))
    }))
}

export function getItemsForSubThemes(diagnostics: Diagnostic[] | undefined, selectedTheme: Theme) {
    return diagnostics?.map((diag) => ({
        perimeter: diag.perimeter,
        completion: diag.themes.find(theme => theme.id === selectedTheme.id)?.rates.completion,
        satisfaction: diag.themes.find(theme => theme.id === selectedTheme.id)?.rates.satisfaction,
        notApplicable: diag.themes.find(theme => theme.id === selectedTheme.id)?.rates.notApplicable,
        subThemes: diag.themes.filter((theme) => theme.id === selectedTheme.id)
            .flatMap((theme) => theme.subThemes).map((subTheme) => ({
                id: subTheme.id,
                label: subTheme.label,
                rates: subTheme.rates,
            }))
    }))
}

export function getHeaderStats(name: string, activePerimeter: number, perimeterSize: number, rates: Rates, perimeterType: PerimeterType): Stats {
    return {
        name: name,
        activePerimeter: activePerimeter,
        sizePerimeter: perimeterSize,
        rates: rates,
        perimeterType: perimeterType
    }
}

export function reportStore() {
    
    return {
        getThemes,
        getThemeLabels,
        getItemsForThemes,
        getItemsForSubThemes,
        getHeaderStats
    }
}
